<template>
  <ul class="tags-list">
    <li v-for="tag in props.tags" :key="tag.id">
      <div class="text-s">
        {{ tag.name }}
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'WidgetTagsList',
}
</script>

<script setup>
const props = defineProps({
  tags: {
    type: Array,
    default: () => [],
  },
})
</script>

<style lang="scss">
@import './style.scss';
</style>
